import { Component } from "react";
import { AlertOctagon } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        data-testid="error-boundary"
        className="m-6 rounded-md border border-rose-200 bg-rose-50 p-8 text-sm text-rose-800"
      >
        <div className="flex items-center gap-2">
          <AlertOctagon className="h-5 w-5" strokeWidth={1.8} />
          <p className="font-display text-lg font-semibold">This page hit a problem</p>
        </div>
        <p className="mt-2">
          {this.state.error?.message || "Something went wrong rendering this screen."}
        </p>
        <button
          data-testid="error-boundary-reload"
          onClick={() => window.location.reload()}
          className="mt-4 rounded bg-rose-600 px-3 py-1.5 text-xs font-semibold text-white"
        >
          Reload page
        </button>
      </div>
    );
  }
}
